import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZaFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53831)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0.000488281 14.6553V35.3449L13.7936 25.0001L0.000488281 14.6553Z",
					fill: "#464655"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.89648 8.62119L22.4138 20.6901H49.9999V9.4832C49.9999 9.00713 49.6139 8.62109 49.1378 8.62109H6.89648V8.62119Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.89648 41.3795L22.4138 29.3105H49.9999V40.5175C49.9999 40.9936 49.6139 41.3796 49.1378 41.3796H6.89648V41.3795Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.55605 8.62109H0.862598C0.386523 8.62109 0.000488281 9.00703 0.000488281 9.48311V13.0192L15.1347 25.0004L0.000488281 36.9818V40.5176C0.000488281 40.9937 0.386523 41.3797 0.862598 41.3797H5.55557L21.8898 28.4486H50.0005V21.5522H21.8899L5.55605 8.62109Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.3334 8.62109H5.55566L21.8896 21.5521H50.0001V19.8279H22.4895L8.3334 8.62109Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.000488281 13.0186V15.2176L12.3569 24.9997L0.000488281 34.7822V36.9811L15.1347 24.9997L0.000488281 13.0186Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.8899 28.4482L5.55566 41.3793H8.3335L22.4897 30.1725H50.0006V28.4482H21.8899Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53831",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgZaFlag);
export { ForwardRef as ReactComponent };
